import React from 'react'
import styled from 'styled-components'

const Container = styled.div`
    width: 100%;
    height: 50px;
    background-color: #333333;
    padding: 5px;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
`

const Text = styled.p`
    color: #f9f9f9;
    text-align: center;
    margin: 0 0 5px 0;
`

const Year = styled.span``

const Owner = styled.span`
    font-size: 13px;
    color: #f7f7f7;
`


function Footer() {
    return (
        <Container>
            <Text>
                All Rights Reserved Grande Roma&copy; <Year>{new Date().getFullYear()}</Year>
            </Text>
            <Owner>Designed and Developed by Flori Disha</Owner>
        </Container>
    )
}

export default Footer
